import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import {
  executeActionSchema,
  type ExecuteAction,
} from '@mls-wallet/shared-types';
import denApi from '@/lib/api/denApi';

/** UI-only label for which DR proposal stream is being reviewed. */
export type DRProposalType = 'initiation' | 'cancellation' | 'finalization';

type ExecuteDRProposalArg = {
  proposalId: string;
  action: ExecuteAction;
};

type ExecuteDRProposalResponse = {
  guardianTransactionId: string;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: ExecuteDRProposalArg }
): Promise<ExecuteDRProposalResponse> => {
  const body = { action: executeActionSchema.parse(arg.action) };

  return await denApi.post<
    ExecuteDRProposalResponse,
    { action: ExecuteAction }
  >(
    `admin/organization/disaster-recovery-proposals/${encodeURIComponent(
      arg.proposalId
    )}/execute`,
    body
  );
};

/**
 * Executes an approved disaster recovery proposal (initiate, cancel, or finalize).
 */
export function useExecuteDRProposal(
  swrOptions?: SWRMutationConfiguration<
    ExecuteDRProposalResponse,
    Error,
    string,
    ExecuteDRProposalArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    ExecuteDRProposalResponse,
    Error,
    string,
    ExecuteDRProposalArg
  >(
    'admin/organization/disaster-recovery-proposals/execute',
    fetcher,
    swrOptions
  );

  return { executeProposal: trigger, isLoading: isMutating, error };
}
